import { createRequestAction } from 'redux-flight-control';

import {
  getUserProfile,
} from './api';

import {
  LOAD_USER_PROFILE,
} from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const loadUserProfile = createRequestAction(LOAD_USER_PROFILE, getUserProfile);




// WEBPACK FOOTER //
// ./redux/user/actions.js